import {Link} from 'react-router-dom';
import {Checkmark, MenuVertical} from '@/components/common/Icons';
import {Show, t, Tooltip} from '@ultradent/components';
import {translationKeys as _} from '@/constants/translations';
import namespace from '@ultradent/utilities/Namespace';
import {allEmptyOrNil, notEmptyOrNil} from '@ultradent/utilities/EmptyOrNil';
import {format} from 'date-fns';

const {requestpublicationemailto, requestpublicationemailcc} = namespace( 'SiteLevelConfiguration.studies' );

export const Taglist = ( {tags = []} ) =>
    tags.map( tag => <Link key={tag.value} className="tag hover:link-2 mr-2 mb-2"
                           to={`/search?keyword=&${tag.group}=${encodeURIComponent( tag.value )}`}>{tag.value}</Link> );

export const ArticleTitle = ( {title} ) => <h3 className="text-lg font-semibold leading-tight mb-3">{title}</h3>;

export const MentionLine = ( {withMention} ) => {
    if ( !withMention ) {
        return null;
    }

    return <p className="flex items-center mb-4">
        <Checkmark width="20" className="mr-2"/>
        {t( 'publicationDetail.label.mentionsUltradent', _.publicationDetail.label.mentionsUltradent )}
    </p>
};

export const RequestLine = ( {claimId, claimTitle, onOpenRequestInfo} ) =>
    <button onClick={() => onOpenRequestInfo( {claimId, claimTitle} )} className="block text-blue font-bold">
        {t( 'publicationDetail.requestPublication.label', _.publicationDetail.requestPublication.label )}
    </button>

export const AccessPublicationLine = ( {articleUrl} ) =>
    <Show when={articleUrl}>
        <a title="Visit article" className="block text-blue font-bold mb-3" href={articleUrl}
           target="_blank"
           rel="noopener">
            {t( 'publicationDetail.actionLabel.accessPublication',
                _.publicationDetail.actionLabel.accessPublication )}
        </a>
    </Show>;

function formatPublishDate ( date, pattern ) {
    let parsedDate = new Date( date );
    return isNaN( parsedDate.getTime() ) ? date : format( parsedDate, pattern );
}

export const PublishedDatesLine = ( {yearStudyPublished, lastUpdatedDate} ) => {
    if ( allEmptyOrNil( [yearStudyPublished, lastUpdatedDate].filter( Boolean ) ) ) {
        return null;
    }

    return <ul className="list-piped text-sm txt-c2 mb-3">
        <Show when={notEmptyOrNil( lastUpdatedDate )}>
            <li>{t( 'publicationDetail.label.claimPublishedWithDate',
                _.publicationDetail.label.claimPublishedWithDate,
                {date: formatPublishDate( lastUpdatedDate, 'yyyy' )} )}</li>
        </Show>
        <Show when={notEmptyOrNil( yearStudyPublished )}>
            <li>{t( 'publicationDetail.label.studyPublishedWithDate',
                _.publicationDetail.label.studyPublishedWithDate,
                {date: formatPublishDate( yearStudyPublished, 'yyyy' )} )}</li>
        </Show>
    </ul>;
}

export const DescriptionLine = ( {withClaim} ) => {
    if ( !withClaim ) {
        return null;
    }

    return <p className="mb-3 text-caption">{withClaim}</p>
}

export const CitationLine = ( {citation} ) =>
    <p className="text-sm txt-c2 leading-snug mb-4 break-all whitespace-pre-wrap">
        <span className="font-bold">
            {t( 'publicationDetail.label.citation', _.publicationDetail.label.citation )}:
        </span> <span dangerouslySetInnerHTML={{__html: citation}}/>
    </p>

export const ApprovedForLine = ( {specificCountries} ) =>
    <div className="mb-4">
        <Show when={notEmptyOrNil( specificCountries )}>
            <ul className="list-piped txt-c2">
            {specificCountries.map( ( country, index ) =>
                <li className="font-bold" key={`${index}-${country}`}>
                    {t( 'publicationDetail.label.approvedFor',
                        _.publicationDetail.label.approvedFor )} {country}
                </li>
            )}
            </ul>
        </Show>
    </div>
export const ContextMenu = props => {
    if ( allEmptyOrNil( [props.articleUrl].filter( Boolean ) ) ) {
        return (
            <button className="cursor-not-allowed">
                <Tooltip content="No actions available" maxWidth={260}>
                    <MenuVertical width="24" height="24" className="text-grey-light"/>
                </Tooltip>
            </button>
        );
    }

    return (
        <Tooltip
            trigger="click"
            maxWidth={480}
            arrow={false}
            placement="bottom-end"
            interactive={true}
            theme="light"
            content={<ContextMenuContent {...props} />}>
            <button className="cursor-pointer">
                <MenuVertical width="24" height="24"/>
            </button>
        </Tooltip>
    )
};

export const ContextMenuContent = ( {articleUrl} ) => {
    return (
        <div className="flex flex-col w-40 text-base">
            {articleUrl &&
                <a href={articleUrl} target="_blank" rel="noreferrer" className="menu-context--item">
                {t( 'publicationDetail.actionLabel.visitArticle', _.publicationDetail.actionLabel.visitArticle )}
            </a>
            }
        </div>
    );
}
